Vue.component('contact-partner', {
    delimiters: ['[[', ']]'],
    template: `
        <div id="contactPartner" class="lqd-modal lity-hide">
            <div class="lqd-modal-inner">

                <div class="lqd-modal-head"></div>

                <div class="lqd-modal-content">

                    <div class="row">
                        <div class="lqd-column col-md-12 px-4 pt-45 pb-30">
                            <div class="row d-flex flex-wrap align-items-center">
                                <div class="lqd-column col-md-6 col-md-offset-1">
                                    <header class="fancy-title">
                                        <h2>Become a partner</h2>
                                        <p>Do you want to join the company, invest or run a partnership with us?</p>
                                    </header>
                                </div>

                                <div class="lqd-column col-md-4 hidden-sm hidden-xs text-right">
                                    <div class="iconbox text-right iconbox-xl" data-animate-icon="true" data-plugin-options='{"resetOnHover":true,"color":"rgb(216, 219, 226)","hoverColor":"rgb(0, 0, 0)"}'>
                                        <div class="iconbox-icon-wrap">
                                            <span class="iconbox-icon-container">
                                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve"> <polygon stroke-width="2" stroke-linejoin="bevel" stroke-miterlimit="10" points="1,30 63,1 23,41" /> <polygon stroke-width="2" stroke-linejoin="bevel" stroke-miterlimit="10" points="34,63 63,1 23,41" /> </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-show="!bSendingMail && !bSendingSuccess">
                                <div class="lqd-column col-md-10 col-md-offset-1">
                                    <div class="contact-form contact-form-inputs-underlined contact-form-button-circle">
                                        <form id="formPartner" action="#" data-url="web/backend/mailer-contact" method="post" novalidate="novalidate">
                                            <div class="row d-flex flex-wrap">
                                                <div class="lqd-column col-md-6 mb-20">
                                                    <input class="lh-25 mb-30" v-model="firstName" type="text" name="first" aria-required="true" aria-invalid="false" placeholder="First Name" required>
                                                    <input class="lh-25 mb-30" v-model="lastName" type="text" name="last" aria-required="true" aria-invalid="false" placeholder="Last Name" required>
                                                    <input class="lh-25 mb-30" v-model="email" type="email" name="email" aria-required="true" aria-invalid="false" placeholder="Email address" required>
                                                    <div id="contact-partner" data-callback="captcha_callback"></div>
                                                </div>

                                                <div class="lqd-column col-md-6 mb-20">
                                                    <textarea cols="10" rows="6" v-model="message" name="message" aria-required="true" aria-invalid="false" placeholder="Message" required></textarea>
                                                </div>
                                                <div class="lqd-column col-md-6">
                                                    <!-- <p class="font-size-16 opacity-07"><em>We all know how important your information is. They are always safe with us.</em></p> -->
                                                </div>

                                                <div class="lqd-column col-md-6 text-md-right">
                                                    <div class="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin" @click="sendEmail()" style='padding:15px; cursor:pointer;'>Send message</div>
                                                </div>

                                                <div v-show="error.length > 0" class="lqd-column col-md-12" style='color:red; text-align:center; margin-bottom:15px'>[[ error ]]</div>

                                            </div>
                                        </form>
                                        <div class="contact-form-result hidden"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-show="bSendingMail && !bSendingSuccess">
                                <h3 class="text-center">Sending email... Please wait</h3>
                                <div class="vertical-align text-center">
                                    <div class="loader vertical-align-middle loader-dot"></div>
                                </div>
                                <br><br>
                            </div>

                            <div class="row" v-show="bSendingSuccess">
                                <div class="lqd-column col-md-10 col-md-offset-1">
                                    <div class="contact-form contact-form-inputs-underlined contact-form-button-circle">
                                        <p class="font-size-22">Thank you for your email, we will come back to you as soon as possible</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="lqd-modal-foot"></div>

            </div>
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
    },
    data: function () {
        return {
            menuType: 1,
            captcha: '',
            error: '',
            bSendingMail: false,
            bSendingSuccess: false,
            email:'',
            message: '',
            firstName: '',
            lastName: '',
        }
    },
    mounted(){

    },
    methods: {
        sendEmail: function(){
            this.error = "";
            var bValid = true;
            if(this.captcha.length == 0){
                this.error = "Please confirm you are not a robot";
                bValid = false;
            }
            if(this.firstName.length == 0){
                this.error = "Please enter your first name";
                bValid = false;
            }
            if(this.lastName.length == 0){
                this.error = "Please enter your last name";
                bValid = false;
            }
            if(this.message.length == 0){
                this.error = "Please enter a message";
                bValid = false;
            }
            if(!this.validateEmail(this.email)){
                this.error = "Please enter a valid email";
                bValid = false;
            }
            if(bValid){
                grecaptcha.reset();
                this.bSendingMail = true;
                var quantDataUrl = $("#formContactUs").data("url");
                var arrPostDict = {'type': 3, 'email': this.email, 'firstName': this.firstName, 'lastName': this.lastName, 'message': this.message, 'captcha': this.captcha};
                var jsonPost = JSON.stringify(arrPostDict);
                axios.defaults.xsrfCookieName = 'csrftoken';
                axios.defaults.xsrfHeaderName = 'X-CSRFToken';
                axios
                    .post(quantDataUrl,{
                        jsonData: jsonPost,
                    })
                    .then(response => {
                        var dataRes = response.data;
                        console.log("dataRes test");
                        console.log(dataRes);
                        this.bSendingMail = false;
                        if (dataRes['res'] == "1"){
                            this.bSendingSuccess =true;
                        }
                        else{
                            this.error = dataRes['msg'];
                        }
                    });
            }
        },
        verifyCallback: function(response){
            this.captcha = response;
        },
        validateEmail: function(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
    },
});